var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add_FILL1_wght600_GRAD0_opsz48",
    d: "M18,26.5a1.151,1.151,0,0,1-1.172-1.172V19.172H10.672a1.172,1.172,0,1,1,0-2.345h6.155V10.672a1.172,1.172,0,1,1,2.345,0v6.155h6.155a1.172,1.172,0,1,1,0,2.345H19.172v6.155A1.151,1.151,0,0,1,18,26.5Z",
    transform: "translate(-9.5 -9.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon_plus.864d6c0d48ff53f9f9116287755fb6eb.svg";
export { ForwardRef as ReactComponent };